import React from 'react';
import { NOTIFICATION_STATUS } from '../../constants';
import { View } from 'react-native';
import CheckCircleIcon from '../../icons/CheckCircleIcon';
import ErrorIconPopover from '../../icons/ErrorIconPopover';
import WarningIconPopover from '../../icons/WarningIconPopover';
import GenricIconPopover from '../../icons/GenricIconPopover';
import styles from './styles';

export default ({ item }) => {
        switch (item.status) {
            case NOTIFICATION_STATUS.ERROR:
                return (
                    <View style={styles.notificationIconWrapper}>
                        <ErrorIconPopover />
                    </View>
                );
            case NOTIFICATION_STATUS.WARNING:
                return (
                    <View style={styles.notificationIconWrapper}>
                        <WarningIconPopover />
                    </View>
                );
            case NOTIFICATION_STATUS.SUCCESS:
                return (
                    <View style={styles.notificationIconWrapper}>
                        <CheckCircleIcon />
                    </View>
                );
            case NOTIFICATION_STATUS.GENERIC:
                return (
                    <View style={[styles.notificationIconWrapper]}>
                        <GenricIconPopover />
                    </View>
                );
            default:
                return (
                    <View style={[styles.notificationIconWrapper]}>
                        <GenricIconPopover />
                    </View>
                );
        }
    };